import React, {lazy} from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';
import {isPublicRoute} from '../../AuthUtils';

const SSOAzureContainer = lazy(() =>
    import(/* webpackChunkName: "authSsoAzure" */ 'app/auth/azure/SsoAzureContainer')
);

export default function LazySsoAzureContainer({children}) {
    let location = useLocation();
    if (isPublicRoute(location.pathname)) {
        return children;
    }

    return <SSOAzureContainer>{children}</SSOAzureContainer>;
}

LazySsoAzureContainer.propTypes = {
    children: PropTypes.node,
};
